var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlWorkingOnLaptopCropped(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "gridItem__media",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      baselineShift: 0,
      clipRule: "nonzero",
      color: "rgb(61, 61, 61)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      cursor: "auto",
      direction: "ltr",
      display: "block",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      font: "400 16px / 18.4px Lato, sans-serif",
      imageRendering: "auto",
      letterSpacing: "normal",
      marker: "none",
      overflow: "hidden",
      paintOrder: "normal",
      pointerEvents: "auto",
      shapeRendering: "auto",
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      textAnchor: "start",
      textDecoration: "none solid rgb(61, 61, 61)",
      textRendering: "auto",
      visibility: "visible",
      wordSpacing: 0,
      writingMode: "horizontal-tb"
    },
    fill: "none",
    viewBox: "228.02 192.6 1144.02 814.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M229.4 604.2L321.6 1007.3H1329L1371.6 674C1372.5 666.8 1372 659.4 1370.1 652.4L1281.5 332C1275.7 311 1258 295.4 1236.5 292.2L561.9 193.2C542.4 190.3 522.9 198.1 510.7 213.6L239.8 557.9C229.5 571 225.7 588 229.4 604.2Z",
    fill: "#F4F4F4",
    style: {
      baselineShift: 0,
      fill: "rgb(244, 244, 244)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.8 432.7C721.901 432.7 730.9 423.701 730.9 412.6C730.9 401.499 721.901 392.5 710.8 392.5C699.699 392.5 690.7 401.499 690.7 412.6C690.7 423.701 699.699 432.7 710.8 432.7Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.2 428.2C702.7 431.8 708.7 433.5 714.9 432.3C725.8 430.1 732.8 419.4 730.5 408.6C730.4 407.9 730.2 407.2 729.9 406.5C720.7 407.1 704.5 413.8 698.2 428.2Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.7 727.4H579.2C572.9 727.4 567.8 722.3 567.8 716V516.8H921.7C928 516.8 933.1 521.9 933.1 528.2V716C933.1 722.3 928 727.4 921.7 727.4Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.1 348.8V639.2L1365 634.2L1286.2 348.8H1032.1Z",
    fill: "#EAEAEA",
    style: {
      baselineShift: 0,
      fill: "rgb(234, 234, 234)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.8 727.4H525.6C519.3 727.4 514.2 722.3 514.2 716V528.1C514.2 521.8 519.3 516.7 525.6 516.7H577.8C584.1 516.7 589.2 521.8 589.2 528.1V716C589.2 722.3 584.1 727.4 577.8 727.4Z",
    fill: "#868A91",
    style: {
      baselineShift: 0,
      fill: "rgb(134, 138, 145)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.2 1006.8H1084.6V688.3C1084.6 682 1079.5 676.9 1073.2 676.9H927.6C921.3 676.9 916.2 682 916.2 688.3V1006.8Z",
    fill: "#868A91",
    style: {
      baselineShift: 0,
      fill: "rgb(134, 138, 145)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047 1006.8H1122V688.3C1122 682 1116.9 676.9 1110.6 676.9H1058.4C1052.1 676.9 1047 682 1047 688.3V1006.8Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.04 861.719V786.719H678.742V861.719H1047.04Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.3 922.7L1013.3 937.6C969.8 872 948.9 853.5 920.1 786.7H720L737.1 721H937.1C950.3 721 962.2 729 967.2 741.2L1050.3 922.7Z",
    fill: "#3F4249",
    style: {
      baselineShift: 0,
      fill: "rgb(63, 66, 73)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1013.2 937.6L1024.5 932.2L934.5 741.2C929.5 729 917.6 721 904.4 721H737.1L720 786.7H893.3H920C948.9 853.5 970.8 873.3 1013.2 937.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M696.668 861.692V786.692H686.068V861.692H696.668Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.4 872.7C1046.1 872.7 1045.8 872.5 1045.8 872.2V737.9C1045.8 737.6 1046.1 737.4 1046.4 737.4C1046.7 737.4 1047 737.6 1047 737.9V872.2C1047 872.5 1046.7 872.7 1046.4 872.7Z",
    fill: "#868A91",
    style: {
      baselineShift: 0,
      fill: "rgb(134, 138, 145)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.9 707L810.9 564.1C807.7 551.5 797.7 541.7 785.1 538.6L761.8 533L694 535.2L658.2 543.7C640.5 547.9 628.9 565.1 631.7 583.1L646.3 676.9C646.5 678.4 657.8 697.2 672.5 711.8H854.1",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M798.6 696.5L798.7 696.4L798.9 696.6L798.6 696.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.6 701.2C833.6 702.4 831.8 702.7 830.5 701.7L812.8 688.7L835.3 699C835.4 699.8 835.1 700.6 834.6 701.2Z",
    fill: "#868A91",
    style: {
      baselineShift: 0,
      fill: "rgb(134, 138, 145)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.1 922.7L932.6 937.6C885.2 871.2 868.2 853.5 839.3 786.7H639.3L656.4 721H856.4C869.6 721 881.5 729 886.5 741.2L970.1 922.7Z",
    fill: "#3F4249",
    style: {
      baselineShift: 0,
      fill: "rgb(63, 66, 73)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M932.6 937.6L942 932.7L866.6 767.1C861.6 754.9 849.7 746.9 836.5 746.9H649.7L639.4 786.7H839.4C868.2 853.5 885.2 871.2 932.6 937.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M393.6 512.1H381.3V560.3V1000.4H384.8V517H393.6V512.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.9 512.1H411.9C416.4 512.1 420.1 508.4 420.1 503.9V478.4H354.8V503.9C354.8 508.4 358.4 512.1 362.9 512.1Z",
    fill: "#61656D",
    style: {
      baselineShift: 0,
      fill: "rgb(97, 101, 109)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.253 1000.34H393.553V512.038H381.253V1000.34Z",
    fill: "#61656D",
    style: {
      baselineShift: 0,
      fill: "rgb(97, 101, 109)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.6 512.1H381.3V989H384.7V516.7H393.6V512.1Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 503.9V497.4H354.8V503.9C354.8 508.4 358.5 512.1 363 512.1H371.2C366.6 512.1 363 508.4 363 503.9Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.6 1006.3C319.3 1006.3 318.5 1003.1 320.6 1002.1C340 992.7 362.9 987.2 387.4 987.2C411.9 987.2 434.8 992.6 454.2 1002.1C456.3 1003.1 455.6 1006.3 453.2 1006.3H321.6Z",
    fill: "#61656D",
    style: {
      baselineShift: 0,
      fill: "rgb(97, 101, 109)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 987.4C392.5 987.3 390 987.2 387.5 987.2C363 987.2 340.1 992.6 320.7 1002.1C318.6 1003.1 319.3 1006.3 321.7 1006.3H344C349.9 998.3 371.7 988.9 395 987.4Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.4 1007.3H276.3C276 1007.3 275.8 1007.1 275.8 1006.8C275.8 1006.5 276 1006.3 276.3 1006.3H1364.5C1364.8 1006.3 1365 1006.5 1365 1006.8C1365 1007.1 1364.7 1007.3 1364.4 1007.3Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.7 922.7L1072.3 974.8C1076.1 980.8 1080.5 982.2 1087.2 984.5L1121.4 995.9C1124.7 997 1120.8 1003.3 1120.8 1003.3C1120.2 1004.1 1119.3 1004.6 1118.2 1004.6C1117.2 1004.6 1116.1 1004.1 1115.4 1003.4C1115.3 1003.3 1115.2 1003.3 1115.2 1003.3H1114.6C1114.5 1003.3 1114.4 1003.4 1114.3 1003.5C1113.7 1004.2 1112.8 1004.6 1111.9 1004.6C1111 1004.6 1109.9 1004.2 1109.2 1003.5C1108.9 1003.2 1108.4 1003.3 1108.1 1003.6C1107.6 1004.2 1106.9 1004.5 1106.1 1004.5C1105.4 1004.5 1104.5 1004.2 1103.8 1003.7C1103.5 1003.5 1103 1003.5 1102.7 1003.8C1102.3 1004.2 1101.6 1004.5 1101 1004.5C1100 1004.5 1099.2 1004 1098.8 1003.2H1098.5L1053.1 1002.5H1053C1047.8 1002.4 1043.7 998.2 1043.5 993L1043.3 989.5C1043.1 985.2 1041.7 981.1 1039.3 977.5L1018.6 943.8L1049.7 922.7Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1122.5 998.5C1121.6 998.5 1120.5 998.1 1119.8 997.4C1119.5 997.1 1119 997.2 1118.7 997.5C1118.2 998.1 1117.5 998.4 1116.7 998.4C1116 998.4 1115.1 998.1 1114.4 997.6C1114.1 997.4 1113.6 997.4 1113.3 997.7C1112.9 998.1 1112.2 998.4 1111.6 998.4C1110.6 998.4 1109.8 997.9 1109.4 997.1H1109.1L1086.7 996.7L1086.1 984C1086.1 984 1081.3 991.4 1074.5 996.6L1063.7 996.3C1059.3 996.2 1055.5 994.5 1053.6 991.1L1031 950.6C1029.9 948.7 1030.5 946.3 1032.3 945L1053.2 930.5L1018.6 943.8L1038.9 976.9C1041.6 980.8 1043.1 985.4 1043.3 990.2L1043.4 993C1043.6 998.2 1047.8 1002.4 1052.9 1002.5H1053L1098.4 1003.2H1098.7C1099.1 1004 1100 1004.5 1100.9 1004.5C1101.6 1004.5 1102.2 1004.2 1102.6 1003.8C1102.9 1003.5 1103.3 1003.5 1103.7 1003.7C1104.4 1004.2 1105.2 1004.5 1106 1004.5C1106.8 1004.5 1107.5 1004.1 1108 1003.6C1108.3 1003.3 1108.8 1003.2 1109.1 1003.5C1109.9 1004.1 1110.9 1004.6 1111.8 1004.6C1112.8 1004.6 1113.6 1004.2 1114.2 1003.5C1114.3 1003.4 1114.4 1003.3 1114.5 1003.3H1115.1C1115.2 1003.3 1115.3 1003.4 1115.3 1003.4C1116.1 1004.1 1117.1 1004.6 1118.1 1004.6C1119.2 1004.6 1120.1 1004.1 1120.7 1003.3C1120.8 1003.3 1123.4 998.5 1122.5 998.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.4 1002.3C1128.2 997.6 1125.2 993.4 1120.7 991.8L1089.1 982.2C1087.9 981.8 1086.7 982.4 1086.3 983.6C1085.1 987.6 1082.1 996.2 1076.2 1002.3H1044.8C1043.6 1002.3 1042.6 1003.3 1042.6 1004.5C1042.6 1005.7 1043.6 1006.7 1044.8 1006.7H1126.2C1127.4 1006.7 1128.4 1005.7 1128.4 1004.5V1002.3Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1128.4 1002.3C1128.3 998.5 1126.3 995.2 1123.3 993.1C1127.2 995.9 1126.5 998.7 1120.9 998.5C1091.8 997.1 1084 997.1 1080.6 996.8C1080.7 996.7 1080.7 996.6 1080.7 996.5C1079.4 998.5 1078 1000.5 1076.3 1002.2H1044.9C1043.7 1002.2 1042.7 1003.2 1042.7 1004.4C1042.7 1005.6 1043.7 1006.6 1044.9 1006.6H1126.3C1127.5 1006.6 1128.5 1005.6 1128.5 1004.4V1002.3H1128.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1128.4 1000.6L1076.9 1001.6L1076.2 1002.3L1128.4 1001.3V1000.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.3 668.5C439 668.5 438.8 668.3 438.8 668V498C438.8 497.7 439 497.5 439.3 497.5C439.6 497.5 439.8 497.7 439.8 498V668C439.8 668.3 439.5 668.5 439.3 668.5Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1114.2 355.1L1223 632.9H1257.3L1146.6 355.1H1114.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1162 355.1L1270.9 632.9H1282.3L1171.6 355.1H1162Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.6 632.9H1206.4V355.1H1287.9L1284.4 342.5H1025.7V645.5H1368L1364.6 632.9ZM1038.4 355.1H1193.8V632.9H1038.4V355.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.6 677H566.8C562.8 677 559.6 673.8 559.6 669.8V627.4H599.9V669.8C599.8 673.8 596.6 677 592.6 677Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.1 662.5H599.8V659.4H606.1C607.7 659.4 609 658.1 609 656.5V639.2C609 637.6 607.7 636.3 606.1 636.3H599.8V633.2H606.1C609.4 633.2 612 635.9 612 639.1V656.4C612.1 659.8 609.4 662.5 606.1 662.5Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M602.6 636.3V633.2H599.8V627.3H591V669C591 672.6 588.1 675.5 584.5 675.5H562.2C563.4 676.5 565 677.1 566.7 677.1H592.5C596.5 677.1 599.7 673.9 599.7 669.9V662.6H602.5V659.5H599.7V636.4H602.6V636.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.3 624.3C573 624.3 572.8 624.1 572.8 623.8C572.8 620 569.7 616.8 565.8 616.8H562.4C559.4 616.8 557 614.4 557 611.4C557 608.4 559.4 606 562.4 606H581.6C584 606 586 604 586 601.6C586 599.2 584 597.2 581.6 597.2H577C573.9 597.2 571.5 594.7 571.5 591.7C571.5 591.4 571.7 591.2 572 591.2C572.3 591.2 572.5 591.4 572.5 591.7C572.5 594.2 574.5 596.2 577 596.2H581.6C584.6 596.2 587 598.6 587 601.6C587 604.6 584.6 607 581.6 607H562.4C560 607 558 609 558 611.4C558 613.8 560 615.8 562.4 615.8H565.8C570.2 615.8 573.8 619.4 573.8 623.8C573.8 624.1 573.6 624.3 573.3 624.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.4 627.4C584.1 627.4 583.9 627.2 583.9 626.9V625.7C583.9 624.8 583.2 624.1 582.3 624.1C580.8 624.1 579.7 622.9 579.7 621.5V619.4C579.7 617.9 580.9 616.8 582.3 616.8H585.5C589.8 616.8 593.4 613.3 593.4 608.9V605C593.4 604.7 593.6 604.5 593.9 604.5C594.2 604.5 594.4 604.7 594.4 605V608.8C594.4 613.7 590.4 617.7 585.5 617.7H582.3C581.4 617.7 580.7 618.4 580.7 619.3V621.4C580.7 622.3 581.4 623 582.3 623C583.8 623 584.9 624.2 584.9 625.6V626.8C584.9 627.1 584.7 627.4 584.4 627.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.1 922.7L991.7 974.8C995.5 980.8 999.9 982.2 1006.6 984.5L1040.8 995.9C1044.1 997 1040.2 1003.3 1040.2 1003.3C1039.6 1004.1 1038.7 1004.6 1037.6 1004.6C1036.6 1004.6 1035.5 1004.1 1034.8 1003.4C1034.7 1003.3 1034.6 1003.3 1034.6 1003.3H1034C1033.9 1003.3 1033.8 1003.4 1033.7 1003.5C1033.1 1004.2 1032.2 1004.6 1031.3 1004.6C1030.4 1004.6 1029.3 1004.2 1028.6 1003.5C1028.3 1003.2 1027.8 1003.3 1027.5 1003.6C1027 1004.2 1026.3 1004.5 1025.5 1004.5C1024.8 1004.5 1023.9 1004.2 1023.2 1003.7C1022.9 1003.5 1022.4 1003.5 1022.1 1003.8C1021.7 1004.2 1021 1004.5 1020.4 1004.5C1019.4 1004.5 1018.6 1004 1018.2 1003.2H1017.9L972.5 1002.5H972.4C967.2 1002.4 963.1 998.2 962.9 993L962.7 989.5C962.5 985.2 961.1 981.1 958.7 977.5L938 944L969.1 922.7Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1041.9 998.5C1041 998.5 1039.9 998.1 1039.2 997.4C1038.9 997.1 1038.4 997.2 1038.1 997.5C1037.6 998.1 1036.9 998.4 1036.1 998.4C1035.4 998.4 1034.5 998.1 1033.8 997.6C1033.5 997.4 1033 997.4 1032.7 997.7C1032.3 998.1 1031.6 998.4 1031 998.4C1030 998.4 1029.2 997.9 1028.8 997.1H1028.5L1006.1 996.7L1005.5 984C1005.5 984 1000.7 991.4 993.9 996.6L983.1 996.3C978.7 996.2 974.9 994.5 973 991.1L950.4 950.6C949.3 948.7 949.9 946.3 951.7 945L972.6 930.5L938 944L958.3 977.1C961 981 962.5 985.6 962.7 990.4L962.8 993.2C963 998.4 967.2 1002.6 972.3 1002.7H972.4L1017.8 1003.4H1018.1C1018.5 1004.2 1019.4 1004.7 1020.3 1004.7C1021 1004.7 1021.6 1004.4 1022 1004C1022.3 1003.7 1022.7 1003.7 1023.1 1003.9C1023.8 1004.4 1024.6 1004.7 1025.4 1004.7C1026.2 1004.7 1026.9 1004.3 1027.4 1003.8C1027.7 1003.5 1028.2 1003.4 1028.5 1003.7C1029.3 1004.3 1030.3 1004.8 1031.2 1004.8C1032.2 1004.8 1033 1004.4 1033.6 1003.7C1033.7 1003.6 1033.8 1003.5 1033.9 1003.5H1034.5C1034.6 1003.5 1034.7 1003.6 1034.7 1003.6C1035.5 1004.3 1036.5 1004.8 1037.5 1004.8C1038.6 1004.8 1039.5 1004.3 1040.1 1003.5C1040.2 1003.3 1042.8 998.5 1041.9 998.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.8 1002.3C1047.6 997.6 1044.6 993.4 1040.1 991.8L1008.5 982.2C1007.3 981.8 1006.1 982.4 1005.7 983.6C1004.5 987.6 1001.5 996.2 995.6 1002.3H964.2C963 1002.3 962 1003.3 962 1004.5C962 1005.7 963 1006.7 964.2 1006.7H1045.6C1046.8 1006.7 1047.8 1005.7 1047.8 1004.5V1002.3Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1047.8 1002.3C1047.7 998.5 1045.7 995.2 1042.7 993.1C1046.6 995.9 1041.9 998.7 1036.3 998.5C1007.2 997.1 1003.4 997.1 1000 996.8C1000.1 996.7 1000.1 996.6 1000.1 996.5C998.8 998.5 997.4 1000.5 995.7 1002.2H964.3C963.1 1002.2 962.1 1003.2 962.1 1004.4C962.1 1005.6 963.1 1006.6 964.3 1006.6H1045.7C1046.9 1006.6 1047.9 1005.6 1047.9 1004.4V1002.3H1047.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1047.8 1001.6H996.3L995.6 1002.3H1047.8V1001.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291.6 867.9L1245.7 917.7L1246 826.1H1244.8L1244.7 870.5L1205.9 831L1205.1 831.8L1244.7 872.2L1244.4 955.2H1245.6L1245.7 919.4L1292.4 868.7L1291.6 867.9Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.4 917.6L1209.6 918.4L1229.8 937.4L1233 955.3L1234.1 955.1L1221.4 883.5L1220.2 883.7L1229.5 935.5L1210.4 917.6Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.3 1006.8H1253.8C1259.1 1006.8 1263.5 1002.5 1263.5 997.1V959.4H1215.6V997.1C1215.6 1002.4 1219.9 1006.8 1225.3 1006.8Z",
    fill: "#61656D",
    style: {
      baselineShift: 0,
      fill: "rgb(97, 101, 109)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.4 826.2C1261.86 826.2 1275.2 812.858 1275.2 796.4C1275.2 779.942 1261.86 766.6 1245.4 766.6C1228.94 766.6 1215.6 779.942 1215.6 796.4C1215.6 812.858 1228.94 826.2 1245.4 826.2Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.7 886.5C1230.46 886.5 1240 876.964 1240 865.2C1240 853.437 1230.46 843.9 1218.7 843.9C1206.94 843.9 1197.4 853.437 1197.4 865.2C1197.4 876.964 1206.94 886.5 1218.7 886.5Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1218.7 886.5C1230.46 886.5 1240 876.964 1240 865.2C1240 853.437 1230.46 843.9 1218.7 843.9C1206.94 843.9 1197.4 853.437 1197.4 865.2C1197.4 876.964 1206.94 886.5 1218.7 886.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1245.4 826.2C1261.86 826.2 1275.2 812.858 1275.2 796.4C1275.2 779.942 1261.86 766.6 1245.4 766.6C1228.94 766.6 1215.6 779.942 1215.6 796.4C1215.6 812.858 1228.94 826.2 1245.4 826.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1199.7 838.3C1206.71 838.3 1212.4 832.614 1212.4 825.6C1212.4 818.586 1206.71 812.9 1199.7 812.9C1192.69 812.9 1187 818.586 1187 825.6C1187 832.614 1192.69 838.3 1199.7 838.3Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.4 923.2C1207.74 923.2 1214.5 916.439 1214.5 908.1C1214.5 899.76 1207.74 893 1199.4 893C1191.06 893 1184.3 899.76 1184.3 908.1C1184.3 916.439 1191.06 923.2 1199.4 923.2Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.2 900.6C1290.86 900.6 1299.5 891.959 1299.5 881.3C1299.5 870.641 1290.86 862 1280.2 862C1269.54 862 1260.9 870.641 1260.9 881.3C1260.9 891.959 1269.54 900.6 1280.2 900.6Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.5 954.3H1214.6C1213.2 954.3 1212.1 955.4 1212.1 956.8C1212.1 958.2 1213.2 959.3 1214.6 959.3H1264.5C1265.9 959.3 1267 958.2 1267 956.8C1267 955.4 1265.9 954.3 1264.5 954.3Z",
    fill: "#61656D",
    style: {
      baselineShift: 0,
      fill: "rgb(97, 101, 109)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.6 796.4C1215.6 779.9 1229 766.6 1245.4 766.6V826.3C1228.9 826.2 1215.6 812.9 1215.6 796.4Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.8 886.3C1210.3 888 1199.6 880.2 1197.6 868.7C1195.7 857.4 1203.1 846.6 1214.3 844.3L1221.8 886.3Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1190.7 834.6C1185.7 829.7 1185.6 821.6 1190.6 816.6C1190.6 816.6 1190.7 816.5 1190.8 816.5L1208.6 834.7C1203.7 839.5 1195.7 839.5 1190.7 834.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1210.1 918.7C1204.2 924.7 1194.6 924.7 1188.7 918.8C1182.8 913 1182.7 903.5 1188.4 897.6L1210.4 918.3C1210.4 918.5 1210.3 918.6 1210.1 918.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.4 959.4H1219.8C1218.4 959.4 1217.3 958.3 1217.3 956.9C1217.3 955.5 1218.4 954.4 1219.8 954.4H1214.5C1213.1 954.4 1212 955.5 1212 956.9C1212 958.3 1213.1 959.4 1214.5 959.4H1215.5V960.2V997.1C1215.5 1002.4 1219.8 1006.8 1225.2 1006.8H1240.4C1240.6 1006.8 1240.7 1006.8 1240.7 1006.8C1233.9 1006.8 1228.1 1002 1226.8 995.4L1219.9 960.2H1263.3V959.4H1263.4Z",
    fill: "#3F4249",
    style: {
      baselineShift: 0,
      fill: "rgb(63, 66, 73)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1293.3 867.1C1293.2 867 1293.1 867 1293.1 866.9L1267.1 895.4L1267.2 895.5C1275 902.7 1287.3 902.2 1294.5 894.4C1301.6 886.5 1301.1 874.3 1293.3 867.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.1 363.2H1038.4V358.6H1288.9L1290.1 363.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.4 371.3H1038.4V366.7H1291.1L1292.4 371.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.6 379.4H1038.4V374.8H1293.3L1294.6 379.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296.9 387.5H1038.4V382.9H1295.6L1296.9 387.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.1 395.6H1038.4V391H1297.8L1299.1 395.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.3 403.7H1038.4V399H1300L1301.3 403.7Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.3 484.2H1044.1V355.2H1043V484.2H1042.8C1041.9 484.2 1041.1 484.9 1041.1 485.9V503.9C1041.1 504.8 1041.8 505.6 1042.8 505.6H1044.3C1045.2 505.6 1046 504.9 1046 503.9V485.9C1046 484.9 1045.3 484.2 1044.3 484.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1040.9 358.6H1038.4V363.2H1040.9V358.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1040.9 366.7H1038.4V371.3H1040.9V366.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1040.9 374.8H1038.4V379.4H1040.9V374.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1040.9 382.9H1038.4V387.5H1040.9V382.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1040.9 390.9H1038.4V395.5H1040.9V390.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1040.9 399H1038.4V403.6H1040.9V399Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1206.4 363.2H1193.8V365.2H1206.4V363.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1206.4 371.3H1193.8V373.3H1206.4V371.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1206.4 379.4H1193.8V381.4H1206.4V379.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1206.4 387.5H1193.8V389.5H1206.4V387.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1206.4 395.6H1193.8V397.6H1206.4V395.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1206.4 403.7H1193.8V405.7H1206.4V403.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5 360.2H430.3L477.5 494.9H297.3L345.5 360.2Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5 360.2H372.3L353.8 494.9H297.3L345.5 360.2Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.439 360.231H430.339V354.131H345.439V360.231Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.353 500.932H477.553V494.832H297.353V500.932Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M345.5 360.2H430.3L477.5 494.9H297.3L345.5 360.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M366.5 360.2H430.3L477.5 494.9H346.2L366.5 360.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M797 571.3L804.3 594.5C807.3 604.1 806.2 613.6 800.9 623L796.2 630.8C795.2 632.4 794.9 634.2 795.2 636.1L805.9 703.5L824.2 669.6L824.1 651.2L798.7 571C798.4 570 796.8 570.3 797 571.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.5 303.7C701.5 280.4 683.9 261.2 661.2 258.7V258.4H656.2C631.2 258.4 610.9 278.7 610.9 303.7C610.9 328.7 631.2 349 656.2 349H661.2V348.7C683.9 346.2 701.5 327 701.5 303.7Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.2 349C686.218 349 706.5 328.719 706.5 303.7C706.5 278.682 686.218 258.4 661.2 258.4C636.181 258.4 615.9 278.682 615.9 303.7C615.9 328.719 636.181 349 661.2 349Z",
    fill: "#868A91",
    style: {
      baselineShift: 0,
      fill: "rgb(134, 138, 145)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.2 344C683.457 344 701.5 325.957 701.5 303.7C701.5 281.443 683.457 263.4 661.2 263.4C638.943 263.4 620.9 281.443 620.9 303.7C620.9 325.957 638.943 344 661.2 344Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.2 344C683.457 344 701.5 325.957 701.5 303.7C701.5 281.443 683.457 263.4 661.2 263.4C638.943 263.4 620.9 281.443 620.9 303.7C620.9 325.957 638.943 344 661.2 344Z",
    fill: "#868A91",
    style: {
      baselineShift: 0,
      fill: "rgb(134, 138, 145)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M661.2 344C683.457 344 701.5 325.957 701.5 303.7C701.5 281.443 683.457 263.4 661.2 263.4C638.943 263.4 620.9 281.443 620.9 303.7C620.9 325.957 638.943 344 661.2 344Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.2 263.4C660.5 263.4 659.8 263.4 659 263.5C680.2 264.6 697.1 282.2 697.1 303.7C697.1 325.2 680.2 342.8 659 343.9C659.7 343.9 660.4 344 661.2 344C683.5 344 701.5 326 701.5 303.7C701.5 281.4 683.5 263.4 661.2 263.4Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.6 306.8L648.2 280.2C647.7 279.2 648.1 277.9 649.1 277.4C650.1 276.9 651.4 277.3 651.9 278.3L663.4 301.2L678.7 293.7C679.7 293.2 681 293.6 681.5 294.7C682 295.7 681.6 297 680.5 297.5L661.6 306.8Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M695.699 324.4C699.399 318.3 701.499 311.2 701.499 303.6C701.499 281.3 683.499 263.3 661.199 263.3C660.099 263.3 658.999 263.4 657.899 263.4L695.699 324.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M651.8 264.5C649.8 265 647.9 265.6 646.1 266.3L687.8 333.9C689.4 332.5 690.9 330.901 692.3 329.201L651.8 264.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M742.3 711.9L733.2 751.3C729.9 765.4 719.6 777.1 705.7 781.4C701.9 782.6 697.8 783.2 693.7 783.2H645.4L653.2 722.1L742.3 711.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.3 711.9L729.4 742.4C723 757.7 708 767.6 691.4 767.6H643.1L650.9 706.5L742.3 711.9Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M776 649.5C774.3 615.4 775.2 539.6 775.4 536.4L761.8 533.1L763.7 645.4C763.7 645.4 777.8 684.3 776 649.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.1 1006.8H634.1C640.4 1006.8 645.5 1001.7 645.5 995.4V688.3C645.5 682 640.4 676.9 634.1 676.9H488.5C482.2 676.9 477.1 682 477.1 688.3V1006.8Z",
    fill: "#868A91",
    style: {
      baselineShift: 0,
      fill: "rgb(134, 138, 145)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.3 678.2H518.9C518.6 678.2 518.4 677.9 518.4 677.5C518.4 677.1 518.6 676.8 518.9 676.8H631.4C631.7 676.8 631.9 677.1 631.9 677.5C631.9 677.9 631.6 678.2 631.3 678.2Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M845.7 709.3L845.3 711.9H854.2L856.5 709.3H845.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.2 496.4C713.5 518 718.9 530.5 706.9 530.1C687.7 529.4 672.7 511.4 673.4 489.8C674.1 468.2 690.3 451.2 709.6 451.9C713.2 470.6 715 474.8 714.2 496.4Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.709 531.873C776.982 531.677 792.451 516.297 792.26 497.521C792.069 478.745 776.29 463.683 757.018 463.879C737.745 464.075 722.276 479.455 722.467 498.231C722.658 517.007 738.436 532.069 757.709 531.873Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.5 481.7L711.9 528.3C711.8 530.1 710.5 531.7 708.7 532.1L694.1 535.3L711.9 565.7L761.9 551.3V533.1L758.6 532.3C756.8 531.9 755.5 530.3 755.4 528.4L753.7 477.1L714.5 481.7Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.3 516.3L740.2 516.2C725.3 515.7 713.7 503.2 714.2 488.3L715.5 450.5C715.7 445.5 719.8 441.6 724.8 441.8L760.1 443C766.6 443.2 771.6 448.6 771.4 455.1L770.2 490.2C769.7 505.2 757.2 516.8 742.3 516.3Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M749.6 504.8H749.5C746.6 504.8 745.1 504.8 745.1 504.8C744.6 504.8 744.1 504.4 744.1 503.8C744.1 503.3 744.5 502.8 745.1 502.8C745.1 502.8 746.6 502.8 749.5 502.8C750 502.8 750.5 503.2 750.5 503.8C750.4 504.3 750.1 504.7 749.6 504.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M749.7 500.6C741.6 501.2 738.3 496.6 737.2 494.3C737 493.8 737.2 493.3 737.6 493.1C738.1 492.9 738.6 493.1 738.8 493.5C739.9 495.7 743.3 500.4 752.7 498.3C754 498.1 754.3 499.7 753.2 500.1C752 500.4 750.8 500.6 749.7 500.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M741.5 481.3C743.102 481.3 744.4 480.002 744.4 478.4C744.4 476.798 743.102 475.5 741.5 475.5C739.898 475.5 738.6 476.798 738.6 478.4C738.6 480.002 739.898 481.3 741.5 481.3Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.6 480.3C742.931 480.3 743.2 480.031 743.2 479.7C743.2 479.369 742.931 479.1 742.6 479.1C742.269 479.1 742 479.369 742 479.7C742 480.031 742.269 480.3 742.6 480.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764 483.4C765.602 483.4 766.9 482.102 766.9 480.5C766.9 478.898 765.602 477.6 764 477.6C762.398 477.6 761.1 478.898 761.1 480.5C761.1 482.102 762.398 483.4 764 483.4Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.3 482.3C765.632 482.3 765.9 482.031 765.9 481.7C765.9 481.369 765.632 481.1 765.3 481.1C764.969 481.1 764.7 481.369 764.7 481.7C764.7 482.031 764.969 482.3 765.3 482.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      baselineShift: 0,
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M753.4 492.8H749.4C748.9 492.8 748.5 492.4 748.5 491.9C748.5 491.4 748.9 491 749.4 491H753.4C754.4 491 755.2 490.2 755.2 489.2C755.2 488.2 754.4 487.4 753.4 487.4C752.9 487.4 752.5 487 752.5 486.5C752.5 486 752.9 485.6 753.4 485.6C755.3 485.6 756.9 487.2 756.9 489.1C756.9 491.2 755.4 492.8 753.4 492.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M781.6 473.5C777.5 470.2 779.6 464.6 779.6 464.6C780.6 462.3 781.3 459.7 781.6 456.9C782.5 447.9 777.9 444.1 775.4 442.7C774.5 442.2 774 441.2 774 440.2C774.3 412 736.4 402.4 715 417.6C702.1 426.8 698.4 437.8 698.6 448.5C698.6 448.5 698.9 453.2 694.5 455.2L699.6 457.8C701.1 465.8 703.9 473.1 705.4 478.8C706 481.2 711.2 471.7 713.3 470.8C713.6 470.7 715.3 473.5 716.4 475.3C717.1 476.4 718.8 476.4 719.3 475.2C721.1 470.6 722.1 465.7 722.3 460.7L722.5 456.2C732.4 455.6 736.9 446.5 736.9 446.5C745.7 458 762 458.1 768.7 457.6C770.3 457.5 771.6 458.7 771.5 460.3L770.9 477.2C770.9 477.2 773.6 474.9 776.3 471L780.5 474.5L781.6 473.5Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.1 490C716.1 490 703.2 491.1 700.4 478.4C697.6 465.7 713.4 463.2 715.7 476L717.5 490H716.1Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M704.3 471.6C705.7 470.6 707 470.3 708.2 470.5C709.4 470.7 710.5 471.6 711.3 473C712.2 474.4 712.7 476.1 712.8 478L712.9 479.4C713 480.4 711.2 480.7 711.2 479.6C711.1 478.1 711.1 478.1 711.1 478.1C711.1 477.7 710.8 475.3 709.9 474C709.3 473 708.6 472.4 707.9 472.3C707.1 472.1 706.3 472.4 705.3 473.1C704.9 473.4 704.4 473.3 704.1 472.9C703.9 472.4 704 471.9 704.3 471.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.3 468.7C763.6 468.7 760.3 470.4 758.2 473.1C755.1 471.7 752.2 472.2 751 472.6C749.1 468.8 745.1 466.1 740.5 466.1C734 466.1 728.8 471.4 728.8 477.8C728.8 484.3 734.1 489.5 740.5 489.5C746.9 489.5 752.2 484.2 752.2 477.8C752.2 476.4 752 475.2 751.5 473.9C752.6 473.6 754.9 473.3 757.3 474.3C756.2 476.1 755.6 478.2 755.6 480.4C755.6 486.9 760.9 492.1 767.3 492.1C773.8 492.1 779 486.8 779 480.4C779 473.9 773.8 468.7 767.3 468.7ZM740.5 488C734.9 488 730.3 483.4 730.3 477.8C730.3 472.2 734.9 467.6 740.5 467.6C746.1 467.6 750.7 472.2 750.7 477.8C750.7 483.4 746.1 488 740.5 488ZM767.3 490.6C761.7 490.6 757.1 486 757.1 480.4C757.1 474.8 761.7 470.2 767.3 470.2C772.9 470.2 777.5 474.8 777.5 480.4C777.5 486 773 490.6 767.3 490.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.6 488.1C714.036 488.1 715.2 486.936 715.2 485.5C715.2 484.064 714.036 482.9 712.6 482.9C711.164 482.9 710 484.064 710 485.5C710 486.936 711.164 488.1 712.6 488.1Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M713.5 487.7C712 487.7 710.7 486.5 710.7 484.9C710.7 484.4 710.9 483.9 711.1 483.4C710.4 483.9 710 484.6 710 485.5C710 486.9 711.1 488.1 712.6 488.1C713.1 488.1 713.7 487.9 714.1 487.6C713.9 487.7 713.7 487.7 713.5 487.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 535.3C694 535.3 740 618 744 710.3L788.2 710.4L787.1 706.4C770.3 654.2 760.2 563.6 761.9 533.1C759.8 548.7 731.5 560.4 706.7 544.5C703.3 542.4 694 535.3 694 535.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.7 556.9C734.3 556.9 733.9 556.9 733.5 556.9C719.1 556.5 706.1 549.5 701.8 544.9C701.5 544.6 701.5 544.1 701.8 543.8C702.1 543.5 702.6 543.5 702.9 543.8C707.1 548.4 720.1 554.9 733.5 555.3C743.8 555.6 752.6 552.3 759.5 545.6C759.8 545.3 760.3 545.3 760.6 545.6C760.9 545.9 760.9 546.4 760.6 546.7C753.7 553.5 744.9 556.9 734.7 556.9Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.9 678.7L764.3 691.4L793.8 692.4C796.9 692.6 798.4 693.5 800.6 696L815 710.3C816 711.5 816.3 712.9 815.2 714C814 715.1 813.1 714.5 811.9 713.4L794.5 699L804.2 713.6C805.3 715.3 805.6 717.2 803.7 717.6C802.6 717.9 801.5 717.5 800.8 716.6L787.4 699.7L797.6 712.6C798.8 714.1 798.1 716.4 796.2 716.9C795.3 717.1 794.3 716.9 793.7 716.2L779 702.2L789 711.7C790.2 712.8 789.9 714.7 788.5 715.5C787.8 715.9 786.9 715.9 786.2 715.5L772.2 707.4C770.8 706.6 769.2 706.5 767.7 707L761.7 709.1C756.8 710.8 751.8 710 746.6 709.3L700.2 704.8L709.9 678.7Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M771.3 705.6C766.4 707.3 761.4 706.5 756.2 705.8L725.1 701L724.8 681.8L716.6 706.3L746.6 709.2C751.7 709.9 756.8 710.6 761.7 709L767.7 706.9C769.2 706.4 770.8 706.5 772.2 707.3L771.3 705.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M788.8 712.2C788.7 712.2 788.6 712.1 788.5 712.1L779.3 703.4C779.1 703.2 779.1 702.9 779.3 702.7C779.5 702.5 779.8 702.5 780 702.7L789.2 711.4C789.4 711.6 789.4 711.9 789.2 712.1C789.1 712.1 789 712.2 788.8 712.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M797.5 713.1C797.4 713.1 797.3 713 797.2 712.9L787.6 700.8C787.4 700.6 787.5 700.3 787.7 700.1C787.9 699.9 788.2 700 788.4 700.2L798 712.3C798.2 712.5 798.1 712.8 797.9 713C797.8 713 797.7 713.1 797.5 713.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M775.6 706.1C778.7 708.2 784.1 711.8 785.9 713.1C788.5 715 789.5 713.1 789.6 713C789.7 713.9 789.3 714.9 788.4 715.4C787.7 715.8 786.8 715.8 786.1 715.4L772.1 707.3C770.7 706.5 769.1 706.4 767.6 706.9L770.7 705.6C772.3 705 774.1 705.2 775.6 706.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.8 681.8L687.6 672.8L646.2 675.8C648.3 689 654.2 700.2 667.3 701.9L716.5 706.3L724.8 681.8Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M674 695.4C663.2 694 658.1 684.8 654.9 675.2L640.3 581.4C637.8 565.1 647.4 548.9 662.4 542.9L658.4 543.9C640.7 548.1 629.1 565.3 631.9 583.3L646.5 677.1C646.5 677.1 646.5 677.1 646.5 677.2C648.8 689.8 654.7 700.4 667.4 702L716.6 706.4L718.9 699.5L674 695.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.1 1006.8H686.1V688.3C686.1 682 681 676.9 674.7 676.9H622.5C616.2 676.9 611.1 682 611.1 688.3V1006.8Z",
    fill: "#B2B6BB",
    style: {
      baselineShift: 0,
      fill: "rgb(178, 182, 187)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M739.3 684.1L701 674.3L675.4 580.8C675.1 579.9 673.7 580.2 673.8 581.1L687.5 672.9L739.1 685.6C739.5 685.7 739.9 685.4 739.9 684.9C740 684.5 739.8 684.1 739.3 684.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.7 715.6H827.3C828.1 715.6 828.8 716.3 828.8 717.1V719.6C828.8 720.4 828.1 721.1 827.3 721.1H728.7C727.9 721.1 727.2 720.4 727.2 719.6V717.1C727.3 716.3 727.9 715.6 728.7 715.6Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M728.7 715.6H827.3C828.1 715.6 828.8 716.3 828.8 717.1V719.6C828.8 720.4 828.1 721.1 827.3 721.1H728.7C727.9 721.1 727.2 720.4 727.2 719.6V717.1C727.3 716.3 727.9 715.6 728.7 715.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.3 715.6H967.2C968 715.6 968.7 716.3 968.7 717.1V719.6C968.7 720.4 968 721.1 967.2 721.1H795.3C794.5 721.1 793.8 720.4 793.8 719.6V717.1C793.8 716.3 794.5 715.6 795.3 715.6Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    style: {
      baselineShift: 0,
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M964.9 716.6H790C789.7 716.6 789.5 716.4 789.5 716.1C789.5 715.8 789.7 715.6 790 715.6H965C965.3 715.6 965.5 715.8 965.5 716.1C965.5 716.4 965.2 716.6 964.9 716.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M794.9 715.6H820.8C822.8 715.6 824.5 714.2 824.9 712.2L846.6 598.1C847.1 595.5 845.1 593.2 842.5 593.2H816.6C814.6 593.2 812.9 594.6 812.5 596.6L790.8 710.7C790.3 713.2 792.3 715.6 794.9 715.6Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M794.9 715.6H820.8C822.8 715.6 824.5 714.2 824.9 712.2L846.6 598.1C847.1 595.5 845.1 593.2 842.5 593.2H816.6C814.6 593.2 812.9 594.6 812.5 596.6L790.8 710.7C790.3 713.2 792.3 715.6 794.9 715.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.6 715.6H964.9C966.9 715.6 968.6 714.2 969 712.2L990.7 598.1C991.2 595.5 989.2 593.2 986.6 593.2H820.3C818.3 593.2 816.6 594.6 816.2 596.6L794.5 710.7C794 713.2 796 715.6 798.6 715.6Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M893.6 651.2C892.6 653.5 893.7 655.5 896 655.5C896.1 655.5 896.3 655.5 896.4 655.5C893.7 658.5 889.6 660.6 886 660.5C881.1 660.4 878.8 656.4 881 651.5C883.1 646.6 888.9 642.8 893.8 642.9C896.9 643 899 644.6 899.5 647.1C897.1 647.1 894.6 648.9 893.6 651.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.6 935.3L937.4 944.8L973.7 930.9L968 918L930.6 935.3Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.6 935.1L1018 944.8L1054.4 930.9L1048.6 918L1011.6 935.1Z",
    className: "change-color-in-svg",
    fill: "#4D61FC",
    style: {
      fill: "rgb(0, 180, 216)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.2 462.2C765.2 462.2 765.1 462.2 765.2 462.2C753.8 461.7 746.3 457.5 742 454.1C737.3 450.4 735.4 446.8 735.3 446.7C735.1 446.3 735.2 445.9 735.6 445.7C736 445.5 736.4 445.6 736.6 446C736.7 446.1 744.3 459.8 765.2 460.7C765.6 460.7 765.9 461.1 765.9 461.5C765.9 461.9 765.6 462.2 765.2 462.2Z",
    fill: "#21252B",
    style: {
      baselineShift: 0,
      fill: "rgb(33, 37, 43)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M714.2 490H717.8L713.5 498.6L714.2 490Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M754.9 513.7C750.8 515.7 746.2 516.5 741.4 516.3C740.4 516.3 739.3 516.2 738.3 516.1C737.9 516 737.5 516 737.1 515.9C737 515.9 736.9 515.9 736.8 515.9C736.2 515.8 735.6 515.7 735 515.5C734.8 515.4 734.5 515.4 734.3 515.3C730.3 514.2 727.4 512.6 725.5 511.3C725.2 511.1 724.7 511.1 724.5 511.5C724.3 511.8 724.3 512.3 724.7 512.5C727.1 514.2 730.9 516.2 736.2 517.2C738.8 519.5 743.4 522.5 749.4 522.8C751.4 522.9 753.3 522.9 755.2 522.6L754.9 513.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M676.2 539.5C682.8 548.4 714.2 596.8 738.6 663.9C726.6 594.8 694 535.3 694 535.3L676.2 539.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlWorkingOnLaptopCropped);
export default __webpack_public_path__ + "static/media/girl-working-on-laptop-cropped.9a9dab90a3f01393d42294a5c8cd421e.svg";
export { ForwardRef as ReactComponent };